import { inject, Injectable, NgZone } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { UserActionLogger } from "./user-action-logger.service";

@Injectable({ providedIn: "root" })
export class GlobalEventListenerService {

    private readonly DOCUMENT = inject(DOCUMENT);
    private readonly NGZONE = inject(NgZone);

    constructor(
        private userActionLogger: UserActionLogger,
    ) {}

    start() {

        this.NGZONE.runOutsideAngular(() => {

            // track field changes
            this.DOCUMENT.addEventListener("change", event => {

                const target = event.target as HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement;
                const { tagName, type, id, name } = target;
                const targetInfo = `(type=${type}, id=${id}, name=${name})`;

                if (tagName === "TEXTAREA") {

                    this.userActionLogger.logAction(`Textarea ${targetInfo} value has been changed`);
                }
                else if (tagName === "SELECT") {

                    this.userActionLogger.logAction(`Select ${targetInfo} value has been changed to ${target.value}`);
                }
                else if (target.type === "radio" || target.type === "checkbox") {

                    const status = (target as HTMLInputElement).checked ? "checked" : "unchecked";
                    this.userActionLogger.logAction(`Input ${targetInfo} has been ${status}`);
                }
                else if (!target.closest("ng-select")) {

                    this.userActionLogger.logAction(`Input ${targetInfo} value has been changed`);
                }
            });

            // track modals
            const observer = new MutationObserver(mutations => {

                for (const mutation of mutations) {

                    if (mutation.addedNodes[0]?.nodeName === "NGB-MODAL-WINDOW") {

                        this.userActionLogger.logAction(`Modal window was opened`);
                    }
                    else if (mutation.removedNodes[0]?.nodeName === "NGB-MODAL-WINDOW") {

                        this.userActionLogger.logAction(`Modal window was closed`);
                    }
                }
            });

            observer.observe(document.body, { subtree: true, childList: true });

            // track button/link clicks
            this.DOCUMENT.addEventListener("click", event => {

                const target = event.target as HTMLElement;
                const closestLink = target.closest("a");
                const closestButton = target.closest("button");

                if (closestLink) {

                    const linkInfo = `(href="${closestLink.href}", class="${closestLink.className}", text="${closestLink.textContent}")`;
                    this.userActionLogger.logAction(`Link ${linkInfo} was clicked`);
                }
                else if (closestButton) {

                    const buttonInfo = `(text="${closestButton.textContent}", class="${closestButton.className}")`;
                    this.userActionLogger.logAction(`Button ${buttonInfo} was clicked`);
                }
            });
        });
    }
}
